import { AlertTriangle, RefreshCw, PenLine } from 'lucide-react'
import { Button } from '../ui/Button'

interface Props {
  detail: string
  onRetry: () => void
  onClose: () => void
  /** P4-4: открыть форму ручного создания с prefilled промптом (вместо простого закрытия). */
  onManual?: () => void
}

/** Inline error block shown on 503 from AI — replaces toast with persistent retry/manual buttons. */
export function AiErrorBlock({ detail, onRetry, onClose, onManual }: Props) {
  return (
    <div className="rounded-xl border border-status-warning/30 bg-status-warning/5 p-4 space-y-3">
      <div className="flex items-start gap-2">
        <AlertTriangle className="w-4 h-4 text-status-warning shrink-0 mt-0.5" />
        <div>
          <p className="text-sm font-semibold text-status-warning">AI не смог обработать запрос</p>
          <p className="text-xs text-text-secondary mt-1">{detail}</p>
        </div>
      </div>
      <div className="flex gap-2">
        <Button variant="ghost" onClick={onRetry} className="flex items-center gap-1.5 text-sm">
          <RefreshCw className="w-3.5 h-3.5" /> Повторить
        </Button>
        <Button
          variant="ghost"
          onClick={onManual ?? onClose}
          className="flex items-center gap-1.5 text-sm"
          data-testid="create-manually"
        >
          <PenLine className="w-3.5 h-3.5" /> Создать вручную
        </Button>
      </div>
    </div>
  )
}